import React from 'react';

const CommonInput = ({ 
    name,
    label,
    value,
    onChange,
    type = 'text',
    placeholder = '',
    required = false,
    disabled = false,
    errors,
    className = 'mb-3 ',
    inputClassName = '',
    displayError = true,
    min,
    max,
    step='any',
    ...props
}) => {
    return (
        <div className={`${className}`}>
            {label && (
                <label className="form-label">
                    {label}
                    {required && <span className="text-danger ms-1">*</span>}
                </label>
            )}
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                className={`form-control ${inputClassName} ${errors?.[name] ? 'is-invalid' : ''}`}
                placeholder={placeholder}
                disabled={disabled}
                autoComplete="off"
                min={type === 'number' ? min : undefined}
                max={type === 'number' ? max : undefined}
                step={type === 'number' ? step : undefined}
                onWheel={type === 'number' ? (e) => e.target.blur() : undefined}
                {...props}
            />
            {displayError && errors?.[name] && (
                <div className="invalid-feedback">
                    {Array.isArray(errors[name]) ? errors[name][0] : errors[name]}
                </div>
            )}
        </div>
    );
};

export default CommonInput; 